import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getImpactFormConfig = () => {
  return {
    Name: {
      fieldId: 'Name',
      formLabel: t(`impacts.fields.Name`),
      columnHeader: t(`impacts.columns.Name`),
    },
    Rationale: {
      fieldId: 'Rationale',
      formLabel: t(`impacts.fields.Rationale`),
      columnHeader: t(`impacts.columns.Rationale`),
      displayType: { displayType: 'textarea' },
    },
    RatingGuidance: {
      fieldId: 'RatingGuidance',
      formLabel: t(`impacts.fields.RatingGuidance`),
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
    },
    LikelihoodAppetite: {
      fieldId: 'LikelihoodAppetite',
      formLabel: t(`impacts.fields.LikelihoodAppetite`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'likelihood_appetite',
      },
      allowAsConditionSource: true,
    },
  } as const satisfies FormConfig;
};
